module.exports = __webpack_public_path__ + "img/about-img_1.1567910a.png";